import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ChevronLeft({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'8px'} height={'14px'} viewBox={'0 0 8 14'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-8.000000, -5.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M15.7071068,17.2928932 C16.0976311,17.6834175 16.0976311,18.3165825 15.7071068,18.7071068 C15.3165825,19.0976311 14.6834175,19.0976311 14.2928932,18.7071068 L8.29289322,12.7071068 C7.90236893,12.3165825 7.90236893,11.6834175 8.29289322,11.2928932 L14.2928932,5.29289322 C14.6834175,4.90236893 15.3165825,4.90236893 15.7071068,5.29289322 C16.0976311,5.68341751 16.0976311,6.31658249 15.7071068,6.70710678 L10.4142136,12 L15.7071068,17.2928932 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

ChevronLeft.propTypes = {
  className: PropTypes.string,
}
